module.exports = __webpack_public_path__ + "img/28_42.152fc6d9.png";